import { motion } from "framer-motion";
import { createPortal } from "react-dom";
import { Icon } from "./Icon";

interface FlyingBookmarkProps {
  startPosition: { x: number; y: number };
  onComplete: () => void;
}

export function FlyingBookmark({
  startPosition,
  onComplete,
}: FlyingBookmarkProps) {
  // Find the actual PinnedBookmarkButton in the DOM to get its real position
  const pinnedButton = document.querySelector(
    "[data-pinned-bookmark-button]",
  ) as HTMLElement;

  // Calculate the end position based on the actual button position
  let endPosition = {
    x: window.innerWidth - 50,
    y: window.innerHeight - 50,
  };

  if (pinnedButton) {
    const rect = pinnedButton.getBoundingClientRect();
    endPosition = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    };
  }

  // Calculate horizontal distance for arc height
  const deltaX = endPosition.x - startPosition.x;
  const deltaY = endPosition.y - startPosition.y;

  // Create a large upward arc (jump up before falling down)
  const arcHeight = -45; // Jump 25px upward at peak

  return createPortal(
    <motion.div
      className="fixed pointer-events-none z-[10000]"
      style={{
        left: startPosition.x,
        top: startPosition.y,
      }}
      initial={{
        x: 0,
        y: 0,
        scale: 1,
        opacity: 1,
        rotate: 0,
      }}
      animate={{
        x: [0, deltaX * 0.75, deltaX],
        y: [0, arcHeight, deltaY],
        scale: [1, 0.8, 0.5],
        opacity: [1, 1, 1, 0.8, 0],
        rotate: [0, 180, 360],
      }}
      transition={{
        duration: 1.0,
        times: [0, 0.4, 1], // Control keyframe timing
        ease: "easeInOut",
        opacity: {
          duration: 1.2,
          times: [0, 0.6, 0.8, 0.9, 1],
          ease: "easeIn",
        },
        rotate: {
          duration: 1.2,
          ease: "linear",
        },
      }}
      onAnimationComplete={onComplete}
    >
      <div className="relative">
        <Icon
          icon="bookmark"
          className="text-emerald-400 text-2xl drop-shadow-[0_0_12px_rgba(52,211,153,0.8)]"
        />
      </div>
    </motion.div>,
    document.body,
  );
}
